/**
 * ID For Mouseflow
 */
export const MOUSEFLOW_APP_ID = 'a052e0a6-b615-49c8-9357-37e9fefe45c2';

/**
 * App key for Userpilot
 */
export const USERPILOT_APP_KEY = 'NX-784197c9';
